export { default } from './DeviceToolbar';
